import { FormFieldTypes } from "../../../../../../../components/finalForms/libs/data/formFieldType";

const initState = {
  lEfficiency: "All",
  isExpiring: false,
  lClientKey: "0",
  isInactive: false,
};

export const addEfficiencyExtractConfig = {
  name: "AddContracts",
  initialState: initState,
  section: [
    {
      sectionId: "efficiencyExtractSection",
      title: "Efficiency Extract Section",
      row: {},
      style: {
        sectionStyle: "mt-2",
      },
      //   wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      rowGroup: [
        {
          groupLabel: "Contact Information", // Group for contact fields
          style: {
            groupStyle: "mb-1 px-2",
          },
          groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
          fields: [
            {
              id: "lEfficiency",
              label: "Efficiency:",
              Field_Name: "Efficiency",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lEfficiency",
              fieldSetting: {
                placeholder: "Select Efficiency",
                options: [
                  { value: "All", label: "All" },
                  { value: "Red", label: "Red" },
                  { value: "Yellow", label: "Yellow" },
                  { value: "Green", label: "Green" },
                ],
              },
              style: {
                containerCss: "col-lg-8 col-md-8 col-8 mb-2 ",
              },
            },
            {
              id: "isExpiring",
              label: "Include Expiring",
              Field_Name: "Include Expiring",
              fieldType: FormFieldTypes.CHECKBOX,
              dataField: "isExpiring",
              fieldSetting: {
                placeholder: "   ",
                subTitle: "",
              },
              style: {
                containerCss: "col-md-4 mb-2 mt-1",
              },
            },
            {
              id: "lClientKey",
              label: "Client:",
              Field_Name: "client",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lClientKey",
              fieldSetting: {
                placeholder: "Select Client",
                allowSpace: true,
                option: []
              },
              style: {
                containerCss: "col-lg-8 col-md-8 col-8 mb-2 ",
              },
            },
            {
              id: "isInactive",
              label: "Include Inactive",
              Field_Name: "Include Inactive",
              fieldType: FormFieldTypes.CHECKBOX,
              dataField: "isInactive",
              style: {
                containerCss: "col-md-4 mb-2 mt-1",
              },
            },

          ],
        },
      ],
    },
  ],
};
